angular.module('components.editor.EditorService', [])

/**
 * The EditorService provides global methods for the editor
 *
 * @class EditorService
 * @constructor
 * @module components.widgets.EditorService
 */
.factory('EditorService', [
  function () {
    'use strict';

    var service = {

      editor: null,

      getModel: function () {
        return JSON.parse(this.editor.getValue());
      }

    };

    return service;
  }
]);
